export const isDailyStatisticsNegative = (dailyStatistics: string) =>
  dailyStatistics < String(0);
